/* eslint-disable react/jsx-wrap-multilines */
import { useState } from 'react';
import {
    FormikValues,
    useFormikContext,
} from 'formik';
import PrimaryButton from '../../Buttons/PrimaryButton';
import { NextStepButtonProps } from './types';
import SubmitFormButton from '../SubmitFormButton';
import ConfirmationModal from '../../modals/ConfirmationModal';
import countOfErrors from '../FormikForm/formikHelpers';

const NextStepButton = ({
    steps,
    currentStepIndex,
    title,
    finalStepTitle,
    finalStepConfirmation,
    className = '', // default props
}: NextStepButtonProps) => {
    const [showModal, setShowModal] = useState(false);
    const {
        errors,
        submitForm,
        validateForm,
    } = useFormikContext<FormikValues>();
    const finalStep = currentStepIndex === steps.length - 1;
    const showModalOnFinalStep = finalStep && finalStepConfirmation !== undefined;
    const isDefaultClick = !showModalOnFinalStep || countOfErrors(errors) > 0;

    const onButtonClick = async () => {
        const formErrors = await validateForm();
        // setTouched(setNestedObjectValues<FormikTouched<FormikValues>>(formErrors, true));
        if (showModalOnFinalStep && !showModal && countOfErrors(formErrors) === 0) {
            setShowModal(true);
        } else {
            submitForm();
        }
    };

    const closeModal = () => setShowModal(false);
    const onModalNo = () => {};

    return (
        <SubmitFormButton>
            {(onClick: any) => (
                <>
                    {
                        (showModalOnFinalStep)
                            ? (
                                <ConfirmationModal
                                    closeModal={closeModal}
                                    isOpen={showModal}
                                    onModalNo={onModalNo}
                                    onModalYes={onClick}
                                    titleText={finalStepConfirmation.modalTitle}
                                    bodyText={finalStepConfirmation.modalBodyText}
                                    noButtonTitle={finalStepConfirmation.noButtonTitle}
                                    yesButtonTitle={finalStepConfirmation.yesButtonTitle}
                                />
                            )
                            : null
                    }

                    <PrimaryButton
                        type={showModalOnFinalStep ? 'button' : 'submit'}
                        data-testid='save-and-next-button'
                        onClick={isDefaultClick ? onClick : () => onButtonClick()}
                        className={className}
                    >
                        {finalStep
                            ? finalStepTitle || 'Submit'
                            : title || 'Save and next'}
                    </PrimaryButton>
                </>)}
        </SubmitFormButton>
    );
};

// NextStepButton.defaultProps = {
//     className: '',
// };

export default NextStepButton;
